import React from "react";
import { Modal, Icon, Form, notification } from "antd";
import { connect } from "react-redux";
import _ from "lodash";
import Request from "../../request";
import BasicCompanyDetails from "./companySetupSteps/basicCompanyDetails";
import LeadSetup from "./companySetupSteps/leadSetup";
import StaffSetup from "./companySetupSteps/staffSetup";
import IntegratonSetup from "./companySetupSteps/integrations";
import UniversitySetup from "./companySetupSteps/universitySetup";
import BankSetup from "./companySetupSteps/bankSetup";
import FinanceSetup from "./companySetupSteps/financeSetup";
import PayrollSettings from "./companySetupSteps/payrollSettings";
import AdminSetting from "./companySetupSteps/adminDetails";

const activeUser = localStorage.getItem('user') ? JSON.parse(localStorage.getItem('user')) : {};

class CompanySetupModal extends React.Component {
    state = {
        visible: true,
        currentStep: 0,
        phoneCodes: [],
        companySettingObject: {},
        staffList: [{ name: '', email: '', userMobileCode: '', userMobile: '', password: '', userGroup: '' }],
        groups: [],
        countries: [],
        countryArray: [],
        buttonLoading: [],
    }

    steps = [
        { title: 'Admin Setup', icon: 'user' },
        { title: 'Company Details', icon: 'shop' },
        { title: 'Bank Details', icon: 'bank' },
        { title: 'Lead Setup', icon: 'usergroup-add' },
        { title: 'Finance Setup', icon: 'dollar' },
        { title: 'Payroll Setup', icon: 'team' },
        { title: 'Staff Setup', icon: 'team' },
        { title: 'University Setup', icon: 'bank' },
        { title: 'Integrations', icon: 'api' },
    ];


    async componentDidMount() {
        await this.loadInitialData();
    }

    loadInitialData = async () => {
        let countryRes = await Request.getCountriesWithoutBusinessAuth({ results: 10000 });

        if (countryRes && !countryRes.error) {
            let countries = [];
            let countryArray = [];
            let buttonLoading = [];

            // ✅ Use a Set to track unique phone codes
            let uniquePhoneCodes = new Set();
            let phoneCodes = [];

            _.each(countryRes.data, (country) => {

                countries.push({
                    _id: country._id,
                    countryName: country.countryName,
                    display: country.countryName
                });

                const code = country.countryPhoneCode;
                if (!code || typeof code !== 'string' || code.trim() === '') {
                    return; // skip invalid / empty
                }
                if (!uniquePhoneCodes.has(code)) {
                    uniquePhoneCodes.add(code);

                    phoneCodes.push({
                        _id: code,
                        display: `${code}(${country.countryName})`
                    });
                }

                countryArray[country._id] = country.countryName;
                buttonLoading[country._id] = 'Save';
            });

            this.setState({ countries, countryArray, buttonLoading, phoneCodes });

            // ⚠️ FIX: you used `.key` but object has `id`
            // if (phoneCodes.length > 0 && this.state.staffList[0].userMobileCode === '') {
            //     let list = _.cloneDeep(this.state.staffList);
            //     list[0].userMobileCode = phoneCodes[0].value; // ✅ FIXED
            //     this.setState({ staffList: list });
            // }
        }

        let userGroups = await Request.loadGroups();
        if (userGroups && userGroups.data) {
            this.setState({ groups: userGroups.data });
        }
    };


    onNext = () => {
        this.setState({ currentStep: this.state.currentStep + 1 });
    }

    onPrev = () => {
        this.setState({ currentStep: this.state.currentStep - 1 });
    }

    handleCloseModal = async () => {
        this.setState({ visible: false });
        let response = await Request.getCompanySetting();
        this.setState({ visible: false }, () => {
            localStorage.setItem('company-details', JSON.stringify(response));
        });
    };


    handleTabClick = (index) => {
        if (index <= this.state.currentStep) {
            this.setState({ currentStep: index });
        }
    };

    handleStaffSubmit = () => {
        const that = this; // Using 'that' instead of 'self' to avoid restricted-globals error
        const staffList = this.state.staffList;
        let hasData = true;

        for (let i = 0; i < staffList.length; i++) {
            const staff = staffList[i];
            if (!staff.name || !staff.email || !staff.userGroup || !staff.userMobile || !staff.password) {
                hasData = false;
                break;
            }
        }

        if (!hasData) {
            this.next();
            return;
        }

        const payload = {
            users: staffList,
            businessId: activeUser.businessId
        };

        Request.addMultiUsers(payload).then(function (res) {
            if (res && !res.error) {
                notification.success({ message: 'Staff Accounts Created Successfully' });
                that.next();
            } else {
                notification.error({
                    message: 'Error creating staff',
                    description: res && res.msg ? res.msg : 'Something went wrong'
                });
            }
        });
    };



    render() {
        const { currentStep, phoneCodes, countries } = this.state;
        return (
            <Modal visible={this.state.visible} closable={false} maskClosable={false} width={1200} centered footer={null} bodyStyle={{ padding: 0, borderRadius: '12px', overflow: 'hidden' }}>
                <style>{`
                    .wizard-modal .ant-form-item-label label { color: #8c8c8c !important; text-transform: uppercase; font-size: 10px !important; font-weight: 700; letter-spacing: 0.5px; }
                    .wizard-modal .ant-input, .wizard-modal .ant-select-selection { border-radius: 4px !important; height: 36px !important; }
                    .active-pill { background: #1890ff !important; color: #fff !important; box-shadow: 0 4px 10px rgba(24, 144, 255, 0.3); }
                    .staff-card { background: #fafafa; padding: 15px; border-radius: 8px; margin-bottom: 12px; border: 1px solid #f0f0f0; }
                    .integration-block { border: 1px solid #e8e8e8; border-radius: 8px; padding: 20px; margin-bottom: 20px; background: #fff; }
                `}</style>

                <div style={{ background: '#e6f7ff', padding: '10px', textAlign: 'center', borderBottom: '1px solid #91d5ff' }}>
                    <span style={{ color: '#0050b3', fontWeight: 600 }}><Icon type="info-circle" style={{ marginRight: 8 }} /> SYSTEM SETUP WIZARD</span>
                </div>

                <div style={{ padding: '30px' }} className="wizard-modal">
                    <div style={{ display: 'flex', gap: '5px', marginBottom: '35px', background: '#f5f5f5', padding: '6px', borderRadius: '40px', width: 'fit-content' }}>
                        {this.steps.map((step, i) => (
                            <div key={i} onClick={() => this.handleTabClick(i)} className={currentStep === i ? 'active-pill' : ''}
                                style={{ padding: '8px 20px', borderRadius: '30px', fontWeight: 600, fontSize: '12px', cursor: i > currentStep ? 'not-allowed' : 'pointer', display: 'flex', alignItems: 'center', gap: '8px', color: currentStep === i ? '#fff' : (i > currentStep ? '#bfbfbf' : '#1890ff') }}>
                                {currentStep > i ? <Icon type="check-circle" theme="filled" style={{ color: '#52c41a' }} /> : <Icon type={step.icon} />}
                                {step.title.toUpperCase()}
                            </div>
                        ))}
                    </div>

                    <div style={{ minHeight: '450px' }}>
                        {currentStep === 0 && (
                            <AdminSetting phoneCodes={phoneCodes} onNext={this.onNext} isModal={true} />
                        )}
                        {currentStep === 1 && (
                            <BasicCompanyDetails phoneCodes={phoneCodes} onNext={this.onNext} onPrev={this.onPrev} isModal={true} />
                        )}

                        {currentStep === 2 && (
                            <BankSetup onNext={this.onNext} onPrev={this.onPrev} isModal={true} />

                        )}

                        {currentStep === 3 && (
                            <LeadSetup onNext={this.onNext} onPrev={this.onPrev} isModal={true} />

                        )}
                        {currentStep === 4 && (
                            <FinanceSetup onNext={this.onNext} onPrev={this.onPrev} isModal={true} />

                        )}

                        {currentStep === 5 && (
                            <PayrollSettings onNext={this.onNext} onPrev={this.onPrev} isModal={true} />
                        )}
                        {currentStep === 6 && (
                            <StaffSetup onNext={this.onNext} onPrev={this.onPrev} phoneCodes={phoneCodes} isModal={true} />
                        )}

                        {currentStep === 7 && (
                            <UniversitySetup countries={countries} onNext={this.onNext} onPrev={this.onPrev} isModal={true} />
                        )}

                        {currentStep === 8 ?
                            <IntegratonSetup onNext={this.onNext} onPrev={this.onPrev} onSuccess={this.handleCloseModal} isModal={true} />
                            : null}

                    </div>
                </div>
            </Modal>
        );
    }
}

const mapStateToProps = ({ global }) => ({ loading: global.buttonLoading });
export default connect(mapStateToProps)(Form.create()(CompanySetupModal));